/**
 * Staffing/KFML-Worklist-Eintrag der Kommandopalette (Issue #36), rein und testbar.
 *
 * Spiegelt exakt sidebar.tsx (KFML_WORKLIST_ITEM + STEERING_ITEMS-Ersetzung, Z. ~190-234):
 * Fuer die Funktionsrolle `kaufm_leitung` ERSETZT „KFML-Worklist" den Staffing-Eintrag
 * (nicht zusaetzlich — zwei Eintraege auf dieselbe Sicht waeren Rauschen). Der Eintrag
 * haengt an der FUNKTIONSROLLE, nicht an der Persona: die Persona ist eine umschaltbare
 * Sicht (users.preferences.active_persona) — hinge die Navigation daran, wuerde der
 * Eintrag beim Umschalten des Dropdowns erscheinen und verschwinden. Beide Varianten
 * haengen am selben Feature-Flag `staffing_neu` (die Worklist enthaelt die Staffing-Ansicht,
 * sie darf nicht sichtbar sein, solange die es nicht ist).
 */
export type StaffingNavCommand = {
  id: string;
  to: string;
  labelKey: string;
  fallbackLabel: string;
};

export function resolveStaffingNavCommand(
  isKfml: boolean,
  showStaffingNeu: boolean,
): StaffingNavCommand | null {
  if (!showStaffingNeu) return null;
  return isKfml
    ? {
        id: 'nav-kfml-worklist',
        to: '/kfml-worklist',
        labelKey: 'v2.nav.kfml_worklist',
        fallbackLabel: 'KFML-Worklist',
      }
    : {
        id: 'nav-staffing',
        to: '/staffing',
        labelKey: 'v2.nav.staffing',
        fallbackLabel: 'Staffing',
      };
}
